var $brandSlider = $(".js-brand-slider");
let brandSliderPlay = false;

if ($(window).width() > 992) {
    $brandSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        speed: 250,
        infinite: true,
        fade: true,
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false
    });
    brandSliderPlay = true;
}
  //brand-logos mobile
var $logosBtn = $('[data-logos-btn]');
var $logosShadow = $('[data-logos-shadow]');
$logosBtn.click(function() {
    $(this).hide();
    $logosShadow.remove();
    $('.brand-logos__items--first .brand-logos__item').addClass('brand-logos__active');
    $('.show-logo').slideDown(10).addClass('brand-logos__active');
    return false;
});

//brand-logos desktop fade slider
$(window).on('scroll resize', function() {
    if ($(window).width() > 992) {
        if (!$brandSlider.hasClass('slick-slider')) {
            $brandSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                speed: 250,
                slickPause: true,
                infinite: true,
                fade: true,
                autoplay: true,
                arrows: false,
                pauseOnHover: false,
                pauseOnFocus: false
            });
            brandSliderPlay = true;
        } else {
            if ($brandSlider.visible() && !brandSliderPlay) {
                $brandSlider.slick("slickPlay");
                brandSliderPlay = true;
            } else if (!$brandSlider.visible() && brandSliderPlay) {
                $brandSlider.slick("slickPause");
                brandSliderPlay = false;
            }
        }
    } else {
        if ($brandSlider.hasClass('slick-slider')) {
            $brandSlider.slick('unslick');
            brandSliderPlay = false;
        }
    };
});